import CreatorDecryptDetailsPage from "./CreatorDecryptDetailsPage";

export default CreatorDecryptDetailsPage;
